// TODO: ADD ENUM FIELDS

export const enums = Object.freeze({
  DEFAULT_ERROR_MESSAGE: "Something went wrong. Please try again later.",
  ADD_SUPPLY_FORM_STORAGE_KEY: "ADD_SUPPLY_FORM_DATA",
  PRESCRIPTION_FORM_STORAGE_KEY: "PRESCRIPTION_FORM_DATA",
  USER_ROLES: {
    ADMIN: "ADMIN",
    MANAGER: "MANAGER",
  },
  USER_STATUS: {
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
  },
  CUSTOMER_TITLES: {
    MR: "MR",
    MRS: "MRS",
    MISS: "MISS",
    REVEREND: "REVEREND",
    DR: "DR",
  },
  GENDER: {
    MALE: "MALE",
    FEMALE: "FEMALE",
    UNISEX: "UNISEX",
  },
  CUSTOMER_TYPES: {
    NORMAL: "NORMAL",
    EYE_CAMP: "EYE_CAMP",
  },
  ORDER_STATUSES: {
    ANY: "ANY",
    CONFIRMED: "CONFIRMED",
    READY: "READY",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
  },
  ORDER_TYPES: {
    SHOP_ORDER: "SHOP_ORDER",
    CAMPAIGN_ORDER: "CAMPAIGN_ORDER",
  },
  PLACE_ORDER: {
    NOW: "NOW",
    LATER: "LATER",
  },
  PAYMENT_TYPES: {
    ADVANCE: "ADVANCE",
    BALANCE: "BALANCE",
    FULL_PAYMENT: "FULL_PAYMENT",
  },
  PAYMENT_METHODS: {
    CASH: "CASH",
    CARD: "CARD",
    BANK_TRANSFER: "BANK_TRANSFER",
    CHEQUE: "CHEQUE",
  },
  ITEM_CATEGORIES: {
    LENSE: "LENSE",
    FRAME: "FRAME",
    ACCESSORIES: "ACCESSORIES",
    SUNGLASS: "SUNGLASS",
  },
  LENSE_COATINGS: {
    UNCOATED: "UNCOATED",
    HMC: "HMC",
    BLUE_CUT: "BLUE_CUT",
    PHOTO_GREY: "PHOTO_GREY",
    PHOTO_BROWN: "PHOTO_BROWN",
    BLUE_CUT_PHOTOCHROMIC: "BC/PG",
    OTHER: "OTHER",
  },
  STOCK_STATUS: {
    PRE_ORDER: "PRE-ORDER",
    READY: "READY",
  },
  ITEM_FILTER_CATEGORIES: {
    LENSE: "LENSE",
    FRAME: "FRAME",
    ACCESSORIES: "ACCESSORIES",
    SUNGLASS: "SUNGLASS",
    ALL: "ALL",
  },

  ITEM_FILTER_STOCK_STATUS: {
    PRE_ORDER: "PRE-ORDER",
    READY: "READY",
    ALL: "ALL",
  },
  ITEM_SORTING_OPTIONS: {
    PRICE_LOW_TO_HIGH: "sellingPrice:asc",
    PRICE_HIGH_TO_LOW: "sellingPrice:desc",
    NEWEST_FIRST: "createdAt:desc",
    OLDEST_FIRST: "createdAt:asc",
    NAME_A_Z: "itemName:asc",
    NAME_Z_A: "itemName:desc",
  },
  MESSAGE_TYPES: {
    INSTANT: "INSTANT",
    SCHEDULE: "SCHEDULE",
    PROMOTIONAL: "PROMOTIONAL",
    TRANSACTIONAL: "TRANSACTIONAL",
  },
  LENSE_TYPES: {
    SV: "SV",
    BF_R_TOP: "BF R-TOP",
    BF_F_TOP: "BF F-TOP",
    PROGESIVEG: "PROGESIVEG",
    POLAROID: "POLAROID",
  },
  REPORTING_PERIODS: {
    DAILY: "DAILY",
    WEEKLY: "WEEKLY",
    MONTHLY: "MONTHLY",
    YEARLY: "YEARLY",
    CUSTOM: "CUSTOM",
  },
  REPORTING_PERIODS_LABELS: {
    DAILY: "DAILY",
    WEEKLY: "THIS WEEK",
    MONTHLY: "THIS MONTH",
    YEARLY: "THIS YEAR",
    CUSTOM: "CUSTOM",
  },
  VIRTUAL_GROUPS: {
    ALL_CUSTOMERS: "ALL_CUSTOMERS",
    ALL_EYE_CAMP_CUSTOMERS: "ALL_EYE_CAMP_CUSTOMERS",
    ALL_SHOP_CUSTOMERS: "ALL_SHOP_CUSTOMERS",
    LAST_DAY_CUSTOMERS: "LAST_DAY_CUSTOMERS",
    LAST_WEEK_CUSTOMERS: "LAST_WEEK_CUSTOMERS",
    LAST_MONTH_CUSTOMERS: "LAST_MONTH_CUSTOMERS",
  },
  FREE_FORM_DESIGNS: {
    ECOLITE: "ECOLITE",
    PRIZMA: "PRIZMA",
    REVOLUTION_PLUS: "REVOLUTION +",
    MAX_VIEW: "MAX VIEW",
  },
});

export const CONFIGURATION = Object.freeze({
  ACCESS_TOKEN_KEY: "ACCESS_TOKEN",
  REFRESH_TOKEN_KEY: "REFRESH_TOKEN",
});
